import { CornerDownRight, Check, Building2 } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";

const benefits = [
  "Plusieurs établissements, une seule organisation",
  "Données séparées par site",
  "Vue globale consolidée",
  "Comparaison entre établissements",
  "Changement instantané d'établissement",
  "Gestion centralisée de l'équipe et de la flotte",
];

const sites = [
  { name: "Agadir", ca: "12 480 €", resa: "86 réservations" },
  { name: "Marrakech", ca: "9 230 €", resa: "64 réservations" },
  { name: "Taghazout", ca: "4 910 €", resa: "31 réservations" },
];

const MultiSites = () => (
  <section data-testid="multi-sites-section" id="multi-sites" className="scroll-mt-24 py-16 sm:py-24 lg:py-32">
    <div className="mx-auto grid max-w-7xl items-center gap-14 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
      <Reveal>
        <Eyebrow index="05">Multi-sites</Eyebrow>
        <h2 className="mt-4 text-balance text-3xl font-bold tracking-tight text-navy sm:text-4xl">
          Un établissement ou dix. Une seule plateforme.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-navy/60 sm:text-lg">
          ActiPilote grandit avec vous : ajoutez des établissements, gardez des données propres à chaque site
          et pilotez l'ensemble depuis une vue consolidée.
        </p>
        <ul className="mt-8 grid gap-3 sm:grid-cols-2">
          {benefits.map((b) => (
            <li key={b} className="flex items-start gap-2.5 text-sm font-medium text-navy/75">
              <Check className="mt-0.5 h-4 w-4 shrink-0 text-turquoise" /> {b}
            </li>
          ))}
        </ul>
      </Reveal>

      <Reveal delay={0.15}>
        <div data-testid="multi-sites-card" className="rounded-3xl border border-slate-200 bg-white p-6 shadow-lift sm:p-8">
          <div className="flex items-center justify-between rounded-2xl bg-navy p-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand text-white"><Building2 className="h-5 w-5" /></span>
              <div>
                <p className="text-sm font-bold text-white">Tous les établissements</p>
                <p className="text-[11px] text-white/50">Vue globale</p>
              </div>
            </div>
            <div className="text-right">
              <p className="font-mono text-lg font-bold text-white">26 620 €</p>
              <p className="text-[10px] font-bold text-turquoise">+21% ce mois</p>
            </div>
          </div>
          <div className="mt-4 space-y-3">
            {sites.map((s, i) => (
              <div key={s.name} data-testid={`site-row-${s.name.toLowerCase()}`} className="flex items-center justify-between rounded-xl border border-slate-200 bg-mist/50 px-5 py-4 transition-colors hover:border-brand/25">
                <div className="flex items-center gap-3">
                  <CornerDownRight className="h-4 w-4 text-navy/30" />
                  <div>
                    <p className="text-sm font-bold text-navy">{s.name}</p>
                    <p className="text-[11px] text-navy/50">{s.resa}</p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="font-mono text-sm font-bold text-navy">{s.ca}</p>
                  <div className="mt-1 h-1 w-20 overflow-hidden rounded-full bg-slate-200">
                    <div className="h-full rounded-full bg-brand" style={{ width: `${[100, 74, 40][i]}%` }} />
                  </div>
                </div>
              </div>
            ))}
          </div>
          <p className="mt-4 text-center text-[11px] font-medium text-navy/40">Basculez d'un établissement à l'autre en un clic.</p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default MultiSites;
